import { useId, useState } from 'react'
import Box from '@mui/material/Box'
import Close from '@mui/icons-material/Close'
import CheckCircle from '@mui/icons-material/CheckCircle'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import smavaIllustration from 'assets/icons/voucher-money-smava-full.png'
import VoucherBenefits from 'components/VoucherBanner/components/VoucherBenefits'
import { VOUCHER_TERMS_URL } from 'components/VoucherBanner/VoucherBanner.constants'
import {
  Banner,
  Content,
  Header,
  Illustration
} from './RCEVariantsBCActivatedBanner.styles'

export interface RCEVariantsBCActivatedBannerProps {
  amount: number
  onTermsClick: () => void
  showIllustration?: boolean
}

const RCEVariantsBCActivatedBanner = ({
  amount,
  onTermsClick,
  showIllustration = false
}: RCEVariantsBCActivatedBannerProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const contentId = useId()
  const toggleLabel = isExpanded ? 'Weniger anzeigen' : 'Mehr erfahren'

  return (
    <Banner aria-label="Aktivierter Gutschein">
      <Content>
        {showIllustration && (
          <Illustration
            src={smavaIllustration}
            alt="Illustration für smava Gutschein"
            aria-hidden="true"
            isExpanded={isExpanded}
          />
        )}
        <Header>
          <Box display="flex" alignItems="center" gap={0.5}>
            <CheckCircle fontSize="small" />
            <Typography variant="h6" fontSize={16} fontWeight={700}>
              Ihr {amount} € Gutschein ist aktiviert!
            </Typography>
          </Box>

          <IconButton
            onClick={() => setIsExpanded((expanded) => !expanded)}
            aria-label={toggleLabel}
            aria-expanded={isExpanded}
            aria-controls={contentId}
            sx={{ color: 'inherit', padding: 0, margin: 0 }}
          >
            {isExpanded ? (
              <Close fontSize="small" />
            ) : (
              <InfoOutlined fontSize="small" />
            )}
          </IconButton>
        </Header>
        <Collapse in={isExpanded}>
          <Box id={contentId} mt={2}>
            <VoucherBenefits
              amount={amount}
              providerName="smava.de"
              termsUrl={VOUCHER_TERMS_URL.smava}
              onTermsClick={onTermsClick}
              variant="smava"
            />
          </Box>
        </Collapse>
      </Content>
    </Banner>
  )
}

export default RCEVariantsBCActivatedBanner
